/**
 * FacetWP filters
 */
var component_facetwp_filters = function(args) {

  // setup args
  var filters = args.filters;


  if (filters) {
    var facetCodes = filters.dataset.facetwpFacet.split(' '); // e.g. data-facetwp-facet="categories tags" (split into array)
    var resetBtn = filters.querySelector('.facetwp-filters__reset-btn');
    resetBtn.addEventListener('click', () => FWP.reset());
    var resultsCount = filters.querySelector('.facetwp-filters__results-count');

    (function($) {
      $(document).on('facetwp-loaded', function() {
        resultsCount.innerHTML = FWP.settings.pager.total_rows + ' ' + theme_strings.results;

        facetCodes.forEach(facet => {
          // show and hide reset filters button
          if (Object.getOwnPropertyDescriptor(FWP.facets, facet).value.length >= 1) {
            resetBtn.classList.add('visible');
          } else {
            resetBtn.classList.remove('visible');
          }
        });

        facetsVisibility(facetCodes);
      });
    })(jQuery);


    // Hide facet and its label if it is empty
    function facetsVisibility(facetCodes) {
      facetCodes.forEach(facetCode => {
        let facet = filters.querySelector(`.facetwp-facet-${facetCode}`);
        let facet_title = filters.querySelector(`.facetwp-filters__facet-label--${facetCode}`);

        if (facet.childNodes.length == 0) {
          facet.style.display = 'none';
          facet_title.style.display = 'none';
        } else {
          facet.style.display = 'block';
          facet_title.style.display = 'block';
        }
      })
    }
  }

  // make the call chainable
  return this;

};

